
export default function Testimonials() {
  const testimonials = [
    {
      rating: 5,
      title: 'IA que transformou nosso negócio',
      text: 'O Neuro Agents implementado revolucionou nosso atendimento ao cliente. Automação inteligente que realmente funciona e trouxe resultados impressionantes em poucos meses.',
      name: 'Mariana Silva',
      role: 'Diretora de Marketing',
      avatar: 'https://public.readdy.ai/ai/img_res/2bb03488bcea5eddc765b5031639d948.jpg'
    },
    {
      rating: 5,
      title: 'Site criado em tempo recorde',
      text: 'Precisávamos de um site profissional com urgência. A ferramenta de criação com IA superou todas as expectativas. Qualidade, velocidade e suporte impecável.',
      name: 'Roberto Oliveira',
      role: 'CEO Startup Tech',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20tech%20entrepreneur%20portrait%2C%20young%20male%20executive%2C%20corporate%20headshot%2C%20dark%20moody%20background%2C%20professional%20photography%2C%20casual%20business%20attire%2C%20dramatic%20lighting&width=200&height=200&seq=avatar-dark-003&orientation=squarish'
    },
    {
      rating: 5,
      title: 'Tecnologia que gera resultados',
      text: 'Os agentes de IA personalizados aumentaram nossa produtividade em 40%. Solução inovadora com implementação rápida e suporte contínuo excepcional.',
      name: 'Fernando Santos',
      role: 'Diretor de Operações',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20executive%20portrait%2C%20confident%20male%20director%2C%20corporate%20headshot%2C%20dark%20moody%20background%2C%20professional%20photography%2C%20formal%20business%20attire%2C%20dramatic%20lighting&width=200&height=200&seq=avatar-dark-005&orientation=squarish'
    },
    {
      rating: 5,
      title: 'Parceiro estratégico em inovação',
      text: 'Mais que um fornecedor, encontrei um parceiro que entende de tecnologia e negócios. Recomendo para qualquer empresa que busca inovação real.',
      name: 'Juliana Rodrigues',
      role: 'Gerente de Inovação',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20businesswoman%20portrait%2C%20young%20female%20manager%2C%20corporate%20headshot%2C%20dark%20moody%20background%2C%20professional%20photography%2C%20modern%20business%20attire%2C%20dramatic%20lighting&width=200&height=200&seq=avatar-dark-006&orientation=squarish'
    }
  ];

  return (
    <section id="depoimentos" className="py-16 sm:py-20 bg-dark-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="mb-12 sm:mb-16">
          <div className="flex items-center mb-4">
            <div className="w-3 h-3 rounded-full bg-red-500 mr-3"></div>
            <span className="text-sm font-semibold text-gray-500 tracking-wider uppercase">
              DEPOIMENTOS
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight">
            O Que Dizem<br />
            Meus <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-600">Clientes</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-400 mt-4">
            Histórias reais de transformação e sucesso
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-dark-700 rounded-xl p-5 sm:p-6 border border-dark-600 hover:border-red-600/30 transition-all duration-300"
            >
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-red-500 text-lg"></i>
                ))}
              </div>
              
              <h3 className="text-base sm:text-lg font-bold text-white mb-3">{testimonial.title}</h3>
              <p className="text-gray-400 mb-6 leading-relaxed text-sm">{testimonial.text}</p>
              
              <div className="flex items-center">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden mr-3 sm:mr-4 flex-shrink-0 border-2 border-red-600/30">
                  <img 
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="font-bold text-white text-sm sm:text-base">{testimonial.name}</p>
                  <p className="text-xs sm:text-sm text-gray-500">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
